export default __webpack_public_path__ + "static/media/news-logo.0c51890e.svg";